export default "__VITE_ASSET__jXYef4rv__"